/* @flow */
import * as React from "react";
import Gettext from "../common/Gettext";
import FeatureFlags from "../../FeatureFlags";
import { isValidNumber } from "libphonenumber-js";

const i18n = {
  agree_error:
    process.env.REACT_APP_DEPLOY_TARGET === "eztrader" ? (
      <Gettext>To continue, you have to be at least 18 years old</Gettext>
    ) : (
      <Gettext>
        To continue, you must agree with the terms or leave the site
      </Gettext>
    ),
  email_address_incorrect: <Gettext>Incorrect e-mail address!</Gettext>,
  email_address_uncorrect: <Gettext>Incorrect e-mail address!</Gettext>,
  error_pass_min_length: (
    <Gettext>Error! The password must be at least 6 characters!</Gettext>
  ),
  error_pass_must_contain_letters_numbers: (
    <Gettext>
      Error! The password must contain only numbers and Latin characters!
    </Gettext>
  ),
  error_repeat_pass_wrong: (
    <Gettext>Error! The verification code does not match!</Gettext>
  ),
  inser_all_fields: (
    <Gettext>Please fill in all of the required fields!</Gettext>
  ),
  operation_completed_with_errror: (
    <Gettext>Sorry, an error has occurred</Gettext>
  ),
  phone_format_incorrect: <Gettext>Incorrect phone number format!</Gettext>,
  register_choose_currency: <Gettext>Choose currency</Gettext>,
};

export default {
  regexprs: {
    emailInvalidSymbols: /[а-яА-Я]/,
    email: /^[a-zA-Z0-9-_.]+@[a-z0-9-_.]+\.[a-z-_.]{2,6}$/,
    password: /[^а-яА-Я]/,
    phone: /^\+?(\d+){6,}$/,
  },
  email: function(val: string) {
    if (this.regexprs.emailInvalidSymbols.test(val)) {
      return i18n.email_address_uncorrect;
    } else return null;
  },
  password: function(val: string) {
    if (val.length < 6) {
      return i18n.error_pass_min_length;
    } else if (!this.regexprs.password.test(val)) {
      return i18n.error_pass_must_contain_letters_numbers;
    } else return null;
  },
  tel: function(val: string) {
    const isValid = FeatureFlags.useCoolPhoneInputOnAuth
      ? isValidNumber(val)
      : this.regexprs.phone.test(val);
    if (!isValid) {
      return i18n.phone_format_incorrect;
    } else return null;
  },
  emailFull: function(val: string) {
    if (!this.regexprs.email.test(val)) {
      return i18n.email_address_incorrect;
    } else return null;
  },
  emptyFields: function(...fields: Array<*>) {
    fields.forEach(function(field) {
      if (field == null) {
        return i18n.inser_all_fields;
      } else return null;
    });
  },
  country: function(country: *) {
    if (country == null || typeof country.currency !== "string") {
      return i18n.register_choose_currency;
    } else return null;
  },
  agree: function(agree: boolean) {
    return agree ? null : i18n.agree_error;
  },
};



// WEBPACK FOOTER //
// ./src/components/Auth/validators.js